import React from "react";

import type { TextListItemBlock, TextListBlock as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SpacerBlock } from "../SpacerBlock";
import { TextListItem } from "./TextListItem";

import styles from "./index.module.scss";

const TextList = ({ value: links }: { value: TextListItemBlock[] }) => {
    return (
        <ul className={styles.list}>
            {links.map((item, index) => (
                <TextListItem key={index} value={item} />
            ))}
        </ul>
    );
};

const components = {
    rich_text_stream: RichTextStreamBlock,
    spacer: SpacerBlock,
    links: TextList,
};

export const TextListBlock = ({ value }: { value: Value }) => {
    if (!value.items) return <></>;

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField
                tagName={React.Fragment}
                components={components}
                value={value.items}
            />
        </Themed>
    );
};
